import { Button } from '@/components/ui/Button';
import { Typography } from '@/components/ui/Text';
import clsx from 'clsx';
import { TBlogWidgetJoinNow } from '../../blog/blog.types';

import './BlogArticleJoinNowWidget.scss';

type Props = {
  widget: TBlogWidgetJoinNow;
  mobile?: boolean;
};

export const BlogArticleJoinNowWidget: React.FC<Props> = ({
  widget: { title, textContent, buttonText, buttonUrl },
  mobile = false,
}) => (
  <div
    className={clsx('BlogArticleJoinNowWidget', {
      'BlogArticleJoinNowWidget--desktop': !mobile,
      'BlogArticleJoinNowWidget--mobile': mobile,
    })}
  >
    <Typography variant='h3'>{title}</Typography>

    <Typography
      className='BlogArticleJoinNowWidget__text-content'
      variant='body-small'
    >
      {textContent}
    </Typography>

    <Button
      className='BlogArticleJoinNowWidget__call-to-action'
      href={buttonUrl}
      variant='dark'
    >
      {buttonText}
    </Button>
  </div>
);
